import React from "react";
import "./StaffAugmentationPage.css";
import StaffAugmentationOverview from "./StaffAugmentationOverview";
import BannerImage from "../../../assets/other_image/staf_agumentation_banners.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";

const StaffAugmentationPage = () => {
  return (
    <section className="StaffAugmentation-process">
            <Banner
        image={BannerImage} // Pass the image for this page
        heading="Staff Augmentation" // Pass the heading text for this page
      />
         <FloatingContactUs />
      
        <StaffAugmentationOverview />
        <section style={{ background: "#f5f7fa" }}>
        <div className="benefits container">
          <h4 className="StaffAugmentation-page-heading">Unlock the Power :</h4>
          <h5 className="StaffAugmentation-subheading">
            Discover the Transformative Benefits of StaffAugmentation-process with NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>Access to a highly skilled technical workforce on flexible contract terms. </li>
            <li>
            Specialization in PLM Tech talent identification and provision across industries.
            </li>
            <li>
            Flexible business models including Contract Staff, Contract to Hire Staff, and Staffing Services. 
            </li>
            <li>
            Structured staffing solutions and processes for streamlined operations. 
            </li>
            <li>
            Primary profile scrutiny by NexTech's in-house Services Technocrats, with final evaluation by the customer. 
            </li>
            <li>
            Convenient accommodation of new talent within the in-house functional team. 
            </li>
            <li>
            Continuous learning and support from NexTech's in-house competency center for enhanced resource performance and value delivery. 
            </li>
          </ul>
        </div>
        </section>
        <section>
        <div className="solutions container">
          <h4 className="StaffAugmentation-page-heading">Our Solutions</h4>
          <ul className="custom-bullets">
            <li>Access elite technical talent through customizable contract models, enhancing your company's competitive edge. </li>
            <li>Specialization in PLM Tech talent acquisition across diverse industries, fostering adaptability. </li>
            <li>Tailored staffing solutions, including Contract Staff, Contract to Hire Staff & Staffing Services, for seamless integration.  </li>
            <li>Rigorous profile vetting by NexTech's in-house Services Technocrats ensures optimal talent selection. </li>
            <li>Empowerment for clients with the final evaluation, promoting alignment with organizational needs. </li>
            <li>Continuous learning and support from NexTech's competency center optimize value delivery. </li>
          </ul>
        </div>
        </section>
        <section style={{ background: "#f5f7fa" }}>
        <div className="why-nextech container">
          <h4 className="StaffAugmentation-page-heading">Why NexTech?</h4>
          <h5 className="StaffAugmentation-subheading">
            For  Staff Augmentation   
          </h5>
          <ul className="custom-bullets">
            <li>
            Highly skilled technical workforce on flexible contract terms. 
            </li>
            <li>
            Specialization in PLM Tech talent identification across industries.  
            </li>
            <li>
            Flexible business models: Contract Staff, Contract to Hire, and Staffing Services.  
            </li>
            <li>
            Structured staffing solutions and processes for streamlined operations.  
            </li>
            <li>
            Primary profile scrutiny by in-house Services Technocrats; final evaluation by the customer. 
            </li>

            <li>
            Easy integration of new talent within the in-house functional team. 
            </li>

            <li>
            Continuous learning and support from NexTech's in-house competency center for optimal performance and value delivery. 
            </li>
            
          </ul>
        </div>

       
      </section>
      <Letsgetintouch />
    </section>
  );
};

export default StaffAugmentationPage;
